import AppHeader from "../components/appheader";
import "./sectioncomplete.scss";
import { useEffect, useRef, useState } from "react";
import { BrandButtonWhite } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import {
  getAppInfo,
  getCurrentSectionandQuestion,
  updateCurrentExamData,
} from "../components/user";
import { ExamQuestion } from "../components/types";

const SectionComplete = () => {
  const [textWarning, setTextWarning] = useState(false);
  const navigate = useNavigate();
  const unansweredLength = useRef(0);
  const sectionLength = useRef(0);
  const examData = getAppInfo()?.currentExamData;
  const { currentSectionId } = getCurrentSectionandQuestion();
  const config = getAppInfo()?.configData;

  const goBack = () => {
    updateCurrentExamData(examData?.examId as number, {
      lastQuestionAnswered:
        examData?.examAnswers[currentSectionId as number].questions[0]
          .questionId,
    });
    navigate(
      "/question/" +
        examData?.examAnswers[currentSectionId as number].questions[0]
          .questionId,
      { replace: true }
    );
  };

  useEffect(() => {
    if (!examData) return;
    const answers: ExamQuestion[] =
      examData?.examAnswers[currentSectionId as number].questions;
    const unanswered = answers.filter((item) => item.value !== null);
    unansweredLength.current = unanswered.length;
    sectionLength.current = answers.length;
    if (unanswered.length !== answers.length) setTextWarning(true);
  }, []);

  return (
    <>
      <div className="sectionCompletePage">
        <AppHeader />
        <div className="pageHeader">
          <h1>
            {config?.questionSections[currentSectionId as number].includes(
              "2a"
            ) ||
            config?.questionSections[currentSectionId as number].includes("2b")
              ? config?.questionSections[currentSectionId as number].substring(
                  0,
                  config.questionSections[currentSectionId as number].length - 1
                )
              : config?.questionSections[currentSectionId as number]}
          </h1>
        </div>
        <div className="pageContent">
          {textWarning && (
            <div className="alertText">
              You only answered {unansweredLength.current} of the{" "}
              {sectionLength.current} questions in this section.
            </div>
          )}
          <div className="btnHolder">
            <BrandButtonWhite onClick={goBack}>GO BACK</BrandButtonWhite>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionComplete;
